<div class="dialog-box">
  <h1 class="dialog-title" mat-dialog-title>Upload History</h1>
  <div mat-dialog-content>
    <table mat-table [dataSource]="dataSource">
      
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th class="name-column" mat-header-cell *matHeaderCellDef> Uploaded File </th>
        <td class="name-column" mat-cell *matCellDef="let element"> 
          <a [href]="element.url" target="_blank" download>{{ element.name }}</a>
        </td>
      </ng-container>

      <!-- File Column -->
      <ng-container matColumnDef="url">
        <th class="name-column" mat-header-cell *matHeaderCellDef>Error Detail File</th>
        <td class="name-column" mat-cell *matCellDef="let element">
          <a *ngIf="element.status === 4" [href]="element.errorUrl" target="_blank" download>ErrorDetails_{{ element.name }}</a>
          <!-- Otherwise, display a dash (-) -->
          <span *ngIf="element.status !== 4">None</span>
        </td>
      </ng-container>

      <!-- Upload By Column -->
      <ng-container matColumnDef="uploadBy">
        <th mat-header-cell *matHeaderCellDef> Upload By </th>
        <td mat-cell *matCellDef="let element"> {{element.uploadBy}} </td>
      </ng-container>

      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef> Date </th>
        <td mat-cell *matCellDef="let element"> {{element.date}} </td>
      </ng-container>

      <!-- Validated Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element"> {{element.status === 4 ? 'Failed' : 'Success'}} </td>
      </ng-container>

      <!-- Header and Row Definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <!-- Pagination -->
    <mat-paginator [pageSizeOptions]="[3, 5, 10]" showFirstLastButtons></mat-paginator>
  </div>
  <div mat-dialog-actions>
    <button class="btn pill-btn btn-back-petronas" mat-dialog-close>Close</button>
  </div>
</div>

